<template>
  <nav class="navbar navbar-expand-lg">
    <div class="container-fluid">
      
      <a href="#" @click="exitImpersonate" class="nav-link btn btn-warning" v-if="isImpersonating()">
              Vous opérez à la place de <b>{{name}}</b> / {{ company }} 
              <i class="nc-icon nc-lock-circle-open" ></i>&nbsp;Retour admin</a>

      <span v-if="!isImpersonating() && !isAdmin()">{{name}} - {{ company }} </span>
      <span v-if="isAdmin()">{{name}}</span>
      
      <button type="button"
              class="navbar-toggler navbar-toggler-right"
              :class="{toggled: $sidebar.showSidebar}"
              aria-controls="navigation-index"
              aria-expanded="true"
              aria-label="Toggle navigation"
              @click="toggleSidebar">
        <span class="navbar-toggler-bar burger-lines"></span>
        <span class="navbar-toggler-bar burger-lines"></span>
        <span class="navbar-toggler-bar burger-lines"></span>
      </button>
      <div class="justify-content-end">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item">

            <!-- Default checked -->
            <div class="nav-link custom-control custom-switch" v-if="isAdmin()">
              <input type="checkbox" class="custom-control-input" id="customSwitch1" :checked="labelEditMode" v-model="labelEditMode" @change="setEditMode()" />
              <label v-if="!labelEditMode" class="custom-control-label" for="customSwitch1">Modifier les textes</label>
              <label v-if="labelEditMode" class="custom-control-label" for="customSwitch1">Enregistrer les textes</label>
            </div>

            
            {{email}}
            <a href="#"  @click="logUserOut" class="nav-link">
              Se déconnecter.
            </a>
          </li>
        </ul>
      </div> 
    </div>
  </nav>
</template>
<script>

  export default {
    /*props : {
      company: String,
    },*/
    data () {
         console.log(this.$usermanager.user)
         return {
           company : this.$usermanager.user['company.name'],
           email   : this.$usermanager.user['email'],
           name    : this.$usermanager.user['name'],

           labelEditMode : this.$features.labelEditMode
         }
     },
    computed: {
      routeName () {
        const {name} = this.$route
        return this.capitalizeFirstLetter(name)
      }
    },
    // data () {
    //   return {
    //     activeNotifications: false
    //   }
    // },
    methods: {
      isAdmin(){
        return this.$usermanager.isAdmin()
      },
      isImpersonating() {
        return this.$usermanager.isImpersonating()
      },
      exitImpersonate() {
        if(this.$usermanager.exitImpersonate()) {
            window.location="/admin/accounts"
        }
      },
      logUserOut() {
        localStorage.removeItem("jwt");
        //this.$router.push("/login");
        window.location="/login"
      },
      capitalizeFirstLetter (string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      },
      toggleNotificationDropDown () {
        this.activeNotifications = !this.activeNotifications
      },
      closeDropDown () {
        this.activeNotifications = false
      },
      toggleSidebar () {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
      },
      hideSidebar () {
        this.$sidebar.displaySidebar(false)
      },
      setEditMode() {
        this.$features.labelEditMode = this.labelEditMode
        this.$eventbus.$emit('on-force-refesh-page')
      },
    }
  }

</script>
<style>

</style>
